export default __webpack_public_path__ + "static/media/GammaTable2Img.fc72d0bb.jpg";